const Loader = ({ isSmall = false, isExtraSmall = false }) => {
  return (
    <div className={`loader ${isSmall ? 'small' : ''} ${isExtraSmall ? 'extra-small' : ''}`}></div>
  )
};

export default Loader;
